"use strict";const e=require("./index23.js"),o=require("./index293.js");var i=e.defineBuiltIn,r=o.errorToString,t=Error.prototype;t.toString!==r&&i(t,"toString",r);
